import { Mail } from "lucide-react";

export default function EmailsCircle() {
  return (
    <div className="w-6 h-6 rounded-full bg-[#18181B] flex items-center justify-center relative">
      <Mail size={12} className="text-[#A1A1AA]" />
      <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-[#60A5FA]" />
    </div>
  );
}
